import { render, staticRenderFns } from "./PreReleaseInfoPanel.vue?vue&type=template&id=ddfbc1bc"
import script from "./PreReleaseInfoPanel.vue?vue&type=script&lang=js"
export * from "./PreReleaseInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./PreReleaseInfoPanel.vue?vue&type=style&index=0&id=ddfbc1bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports